module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('section', [_c('dl', {
    staticClass: "field",
    staticStyle: {
      "height": "65px"
    }
  }, [_c('span', {
    staticClass: "f-strong"
  }, [_vm._v("订单号：" + _vm._s(_vm.orderId))]), _vm._v(" "), _c('dd', {
    staticClass: "right-item f-strongest"
  }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.totalFee)))])])]), _vm._v(" "), _c('section', {
    staticClass: "qrcode-info"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQR),
      expression: "showQR"
    }]
  }, [_c('div', {
    staticClass: "qc-code qrcode-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShow),
      expression: "!isShow"
    }],
    staticClass: "row f-minor"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-right": "8px"
    }
  }, [_vm._v("二维码还有 "), _c('span', {
    staticClass: "f-strongest"
  }, [_vm._v(_vm._s(_vm.btnTime))]), _vm._v(" 秒失效!")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "row f-minor"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]), _vm._v(" "), _c('qrcode', {
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "size": 175,
      "cls": _vm.qrCls,
      "value": _vm.qrText
    }
  })], 1), _vm._v(" "), _c('o2o-helper', {
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "type": 3,
      "isShow": true,
      "hasArrow": false
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPending),
      expression: "showPending"
    }]
  }, [_c('div', {
    staticClass: "success-scan"
  }), _vm._v(" "), _c('div', {
    staticClass: "qc-code qrcode-container scan_succ"
  }), _vm._v(" "), _c('p', {
    staticClass: "qrcode-instructor f-strong",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("扫码成功!")]), _vm._v(" "), _c('p', {
    staticClass: "qrcode-instructor",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("请在自助机上完成支付")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuccess),
      expression: "showSuccess"
    }]
  }, [_c('div', {
    staticClass: "qc-code qrcode-container pay_succ"
  }), _vm._v(" "), _c('p', {
    staticClass: "qrcode-instructor",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("支付成功")])]), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "erweima"
  }, [_c('button', {
    staticClass: "refresh-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.change
    }
  }, [_vm._v("刷新二维码")])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aaf23e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pay/SelfPay.vue
// module id = 814
// module chunks = 0